import Vue from 'vue';

export default {
    changeLang({commit}, lang) {
        commit('CHANGE_LANG', lang);
    },
    // L'action de base ne prenait que le champs email (ce qui était une bétise) pour assurer la rétrocampatibilité de cette action
    // on test la donné en paramétre et en fonction de ce type on set le champs email
    async createUserAccount({rootState, dispatch, rootGetters}, data) {
        let email = '';
        if(typeof(data) === 'object'){
            email = data.email;
        }else{
            email = data;
        }
        let user = null;

        // Check if user already exists
        let existingUser = null;
        try{
            let response = await this.axios.get(`user/?email=${email}`);
            if(response.data.total_objects_count == 1){
                existingUser = response.data.results[0];
            }
        }
        catch(error){
            console.error(error);
        }

        try {
            let headers = rootState.api.scopes || {};
            if(data.scopes !== undefined){
                headers = data.scopes;
                delete data.scopes;
            }

            let item = {
                email: email,
                url_format: rootGetters.emailOnRegisterSetPasswordLinkFormat || rootGetters['fundation/emailOnRegisterSetPasswordLinkFormat'],
                email_format: rootGetters.emailOnRegisterContentFormat || rootGetters['fundation/emailOnRegisterContentFormat'],
            };
            if(typeof(data) === 'object'){
                Object.assign(item, data);
            }

            let response = await this.axios.post('auth/register/', item, {headers});
            // response.status === 201
            user = response.data;
            if(response.status === 201){
                user.created = true;
                try{
                    // This action could be overriden within project that uses fundation
                    // If it is not overriden, there will be no error
                    dispatch('onUserCreated', user, { root: true });
                    // Overridable action
                    // async onUserCreated({getters}, user){
                    //     console.debug('Action onUserCreated called with user : ');
                    //     console.debug(user);
                    // },
                } catch(error){
                    // eslint-disable
                }
            }
            else{
                try{
                    // This action could be overriden within project that uses fundation
                    // If it is not overriden, there will be no error
                    dispatch('onUserUpdated', {newUser: user, oldUser: existingUser}, { root: true });
                    // Overridable action
                    // async onUserUpdated({getters}, {newUser, oldUser}){
                    //     console.debug('Action onUserUpdated called with user : ');
                    //     console.debug(newUser);
                    // },
                } catch(error){
                    // eslint-disable
                }
            }
        }
        catch(error){
            console.error(error);
            if(error.toString().includes('403')){
                return Promise.resolve();
            }
            return Promise.reject(`Error while registering the new
                user ${email}`);
        }
        return Promise.resolve(user);
    },

    async deleteUser ({commit, rootState}, user){
        let headers = rootState.api.scopes || {};
        if(user.scopes !== undefined){
            headers = user.scopes;
            delete user.scopes;
        }
        return this.axios.delete(user.url, {headers}).then(() => {
            let deleteItem = {
                modelName: 'users',
                itemUid: user.uid
            };
            if(rootState.api.meta.listModels.users.fetch !== false){
                commit('DELETE_ITEM', deleteItem, { root: true });
            }
        });
    },

    async createGroup({dispatch, rootState}, {groupName='new group', membersUid=null}){
        if(membersUid === null){
            membersUid = [];
        }
        let scopes = rootState.api.scopes || {};
        return new Promise((resolve, reject) => {
            dispatch('createItem', {
                item: {
                    name: groupName,
                    members_uid: membersUid,
                },
                url: 'group/',
                model: 'groups',
                scopes: scopes,
            }, {root: true}).then((group) => {
                resolve(group);
            }, error => {
                console.error(error);
                reject(`Cannot create group "${groupName}"`);
            });
        });
    },
    async addUsersToGroup({getters, dispatch}, {users, group}) {
        let modified = false;
        let groupClone = JSON.parse(JSON.stringify(group));
        let canViewUsers = groupClone.can_view_users;
        let members = groupClone.members_uid;
        for(let user of users){
            if(!members.includes(user.uid)){
                modified = true;
                members.push(user.uid);
            }
            if(getters.usersCanViewTheirOwnGroups) {
                if(!canViewUsers.includes(user.uid)){
                    modified = true;
                    canViewUsers.push(user.uid);
                }
            }
        }
        if(!modified){
            return Promise.resolve(group);
        }

        let item = {
            uid: groupClone.uid,
            members_uid: members,
            url: groupClone.url,
            can_view_users: canViewUsers,
        };

        return dispatch('patchItem', {
            item: item,
            model: 'groups',
        }, {root: true});
    },
    async removeUsersFromGroup({dispatch}, {users, group}) {

        let modified = false;
        let usersUid = users.map(user => user.uid);

        group.members_uid = group.members_uid.filter(uid => {
            if(usersUid.includes(uid)){
                modified = true;
                return false;
            }
            return true;
        });
        group.can_view_users = group.can_view_users.filter(uid => {
            if(usersUid.includes(uid)){
                modified = true;
                return false;
            }
            return true;
        });

        if(!modified){
            return Promise.resolve(group);
        }

        let item = {
            uid: group.uid,
            members_uid: group.members_uid,
            url: group.url,
            can_view_users: group.can_view_users,
        };

        return dispatch('patchItem', {
            item: item,
            model: 'groups',
        }, {root: true});
    },

    async addUsersToGroups({dispatch}, {users, groups}) {
        let promises = [];
        for(let group of groups) {

            promises.push(dispatch('addUsersToGroup', {
                users: users,
                group: group
            }));
        }
        return Promise.all(promises);
    },

    async removeUsersFromGroups({dispatch}, {users, groups}) {
        let promises = [];
        for(let group of groups) {
            promises.push(dispatch('removeUsersFromGroup', {
                users: users,
                group: group
            }));
        }
        return Promise.all(promises);
    },

    async grantAccessToGroup({dispatch}, {instance, group, modelName}){
        let can_view_groups = JSON.parse(JSON.stringify(instance.can_view_groups));
        if(!can_view_groups.includes(group.uid)){
            can_view_groups.push(group.uid);
            try{
                await dispatch('patchItem', {
                    item: {
                        uid: instance.uid,
                        can_view_groups: can_view_groups,
                        url: instance.url
                    },
                    model: modelName,
                }, {root: true});
            }
            catch(error){
                console.error(error);
                return Promise.reject(error);
            }
        }
        return Promise.resolve();
    },
    async removeAccessToGroup({dispatch}, {instance, group, modelName}){
        let can_view_groups = JSON.parse(JSON.stringify(instance.can_view_groups));
        if(can_view_groups.includes(group.uid)){
            can_view_groups.splice(can_view_groups.indexOf(group.uid), 1);
            try{
                await dispatch('patchItem', {
                    item: {
                        uid: instance.uid,
                        can_view_groups: can_view_groups,
                        url: instance.url
                    },
                    model: modelName,
                }, {root: true});
            }
            catch(error){
                console.error(error);
                return Promise.reject(error);
            }
        }
        return Promise.resolve();
    },
    async grantdAccessToUser({dispatch}, {instance, user, modelName}){
        let can_view_users = JSON.parse(JSON.stringify(instance.can_view_users));
        if(!can_view_users.includes(user.uid)){
            can_view_users.push(user.uid);
            try{
                await dispatch('patchItem', {
                    item: {
                        uid: instance.uid,
                        can_view_users: can_view_users,
                        url: instance.url
                    },
                    model: modelName,
                }, {root: true});
            }
            catch(error){
                console.error(error);
                return Promise.reject(error);
            }
        }
        return Promise.resolve();
    },
    async removeAccessToUser({dispatch}, {instance, user, modelName}){
        let can_view_users = JSON.parse(JSON.stringify(instance.can_view_users));
        if(can_view_users.includes(user.uid)){
            can_view_users.splice(can_view_users.indexOf(user.uid), 1);
            try{
                await dispatch('patchItem', {
                    item: {
                        uid: instance.uid,
                        can_view_users: can_view_users,
                        url: instance.url
                    },
                    model: modelName,
                }, {root: true});
            }
            catch(error){
                console.error(error);
                return Promise.reject(error);
            }
        }
        return Promise.resolve();
    },
    set_loading_start({commit}){
        return commit('SET_LOADING_START');
    },
    set_loading_end({commit}){
        return commit('SET_LOADING_END');
    },
    set_online({commit}) {
        return commit('SET_ONLINE');
    },
    set_offline({commit}) {
        return commit('SET_OFFLINE');
    },
    need_update({commit}) {
        return commit('SET_UPDATE_STATUS', true);
    },
    is_up_to_date({commit}) {
        return commit('SET_UPDATE_STATUS', false);
    },
    set_focus_true({commit}) {
        return commit('SET_FOCUS_STATUS', true);
    },
    set_focus_false({commit}) {
        return commit('SET_FOCUS_STATUS', false);
    },
    change_burger_menu_value({commit}, value) {
        return commit('CHANGE_BURGER_MENU_STATUS', value);
    },

    updateArrayOfItems (context, {srcArray, targetArray}){
        if(!(srcArray instanceof Array) && !(targetArray instanceof Array)){
            console.warn('NO MODIFICATION DONE. PARAMETER MUST BE AN OBJECT WITH KEYS srcArray AND targetArray WICH MUST BE ARRAY');
            return srcArray;
        }
        let srcItemToDestroyIndex = [];
        let targetItemFound = [];
        for(let item of srcArray){
            let targetItem = targetArray.find((targetItem) => targetItem.uid === item.uid);
            if(!targetItem){
                // then an index to srcItemToDestroyIndex array
                srcItemToDestroyIndex.push(srcArray.findIndex((_item) => _item.uid === item.uid));
            }else{
                for (let key in item){
                    if(typeof targetItem[key] === 'object'){
                        if(JSON.stringify(targetItem[key]) === JSON.stringify(item[key])){
                            continue;
                        }else{
                            Vue.set(item, key, targetItem[key]);
                        }
                    }else{
                        item[key] = targetItem[key];
                    }
                }
                targetItemFound.push(targetItem.uid);
            }
        }
        // reverse array for avoid to mess up the index
        srcItemToDestroyIndex = srcItemToDestroyIndex.reverse();
        // destroy items is srcArray not in targetArray
        for(let index of srcItemToDestroyIndex){
            srcArray.splice(index, 1);
        }

        // add new item to srcArray
        for( let item of targetArray){
            if(!targetItemFound.includes(item.uid)){
                srcArray.push(item);
            }
        }
        return srcArray;
    },
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/store/actions.js
// module id = null
// module chunks = 